import { useEffect, useState } from "react";

// Client for /api/integrations — API Keys & Integrations vault + map config.
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const MAP_EVT = "map-config-changed";

async function j(method, path, { body, actor } = {}) {
  const res = await fetch(`${BACKEND}/api/integrations${path}`, {
    method,
    headers: {
      ...(body ? { "Content-Type": "application/json" } : {}),
      ...(actor ? { "X-Actor": actor.employeeId || "", "X-Actor-Role": actor.role || "" } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  let payload = null;
  try { payload = text ? JSON.parse(text) : null; } catch { payload = null; }
  if (!res.ok) {
    const d = payload?.detail;
    const msg = Array.isArray(d) ? d.map(x => x.msg).join("; ") : d || `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return payload;
}

export const listServices = (actor) => j("GET", "/services", { actor });
export const saveService = (service, values, actor) =>
  j("PUT", `/services/${encodeURIComponent(service)}`, { body: { values }, actor });
export const createCustomKey = (body, actor) => j("POST", "/services/custom", { body, actor });
export const clearService = (service, actor) => j("DELETE", `/services/${encodeURIComponent(service)}`, { actor });
export const testService = (service, actor) => j("POST", `/services/${encodeURIComponent(service)}/test`, { actor });
export const setMapProvider = (provider, actor) => j("PUT", "/map-provider", { body: { provider }, actor });
export const listKeyAudit = (actor, limit = 40) => j("GET", `/audit?limit=${limit}`, { actor });
export const getMapConfig = () => j("GET", "/map-config");

export function notifyMapConfigChanged() {
  window.dispatchEvent(new Event(MAP_EVT));
}

// Active basemap config; refetches whenever the admin console changes keys/provider.
export function useMapConfig() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => getMapConfig().then(c => alive && setCfg(c)).catch(() => alive && setCfg(null));
    load();
    window.addEventListener(MAP_EVT, load);
    return () => { alive = false; window.removeEventListener(MAP_EVT, load); };
  }, []);
  return cfg;
}
